//React
import React from "react";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as notificationAction from '../action/notificationAction';

import Cookies from 'js-cookie';

class Comp extends React.Component {
  constructor(props) {
    super(props);
  	this.state = {
  		menuHeaderToggleVisible: false,
  	}
  }

  componentDidMount() {
    this.props.myProfileGet([]);
    this.props.notificationGet();
    Cookies.set('appMode', 'pwa', {domain:'.partner-s.net', expires:365 , path:'/', samesite: 'lax'});
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      //プロフ
      if (this.props.location.pathname === '/') {
        this.props.myProfileGet([]);
      }
      else if (this.props.location.pathname === '/setting/charged/') {
        this.props.myProfileGet([]);
      }
      else if ( ((new Date()) - this.props.my.profile.datetime) > (300*1000) ) {
        this.props.myProfileGet([]);
      }
      //通知
      if ( ((new Date()) - this.props.notification.datetime) > (20*1000) ) {
        this.props.notificationGet();
      }
      Cookies.set('appMode', 'pwa', {domain:'.partner-s.net', expires:365 , path:'/', samesite: 'lax'});
    }
  }

	render() {
    if (
      (this.props.my.setting.datetime && this.props.my.setting.profileCheck === 0) &&
      (this.props.my.profile.datetime) &&
      !this.props.location.pathname.match(/^\/new\//)
    ) {
      if (!this.props.my.profile.userdata_prof_region) {
        this.props.history.push('/new/user/');
      }
      else if (!this.props.my.profile.userdata_prof_partner_region) {
        this.props.history.push('/new/partner/');
      }
      else {
        this.props.history.push('/new/comment/');
      }
    }

		return null
	}
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
    notification: state.notification,
	}
};
const mapDispatchToProps = dispatch => (
	bindActionCreators({
    ...myProfileAction,
    ...notificationAction,
	}, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
